const autocompleteKeyboardNavigation = (position, e, acSearchResult) => {
    let newPosition = position;
    if (e.keyCode === 38) { // Up arrow
        if (position === 0) { // The first one is activated, and the up arrow was clicked, stop navigation.
            newPosition = null;
        }
        else if (position > 0) { // Another but the first one is activated.
            newPosition--;
        }
        e.preventDefault();
    }
    else if (e.keyCode === 40) { // Down arrow
        if (position === null) { // First time: activate the first one.
            newPosition = 0;
        }
        else if (position < acSearchResult.length - 1) { // Not first time: activate the next one, if such exists.
            newPosition++;
        }
        else if (position === acSearchResult.length - 1) {
            newPosition = null;
        }
        e.preventDefault();
    }
    return newPosition;
};

export default autocompleteKeyboardNavigation;
